import React from "react";
import { CheckCircle2 } from "lucide-react";

interface VerifiedBadgeProps {
  isVerified: boolean;
  size?: "sm" | "md" | "lg";
  showText?: boolean;
  className?: string;
}

const VerifiedBadge: React.FC<VerifiedBadgeProps> = ({
  isVerified,
  size = "md",
  showText = false,
  className = "",
}) => {
  if (!isVerified) return null;

  const sizeClasses = {
    sm: "h-3.5 w-3.5",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  };

  const textSizeClasses = {
    sm: "text-[11px]",
    md: "text-sm",
    lg: "text-base",
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-pill bg-success/10 px-2 py-1 font-semibold text-success ${className}`}
    >
      <CheckCircle2
        className={`${sizeClasses[size]} flex-none`}
        strokeWidth={1.75}
        aria-hidden="true"
      />
      {showText && (
        <span className={`${textSizeClasses[size]} leading-none`}>
          Verified
        </span>
      )}
    </span>
  );
};

export default VerifiedBadge;
